var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.money(_vm.rollover.budget)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(_vm.rollover.spend)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.money(_vm.rollover.rollover)))]),_vm._v(" "),_c('td',[_c('btn',{attrs:{"click":_vm.apply}},[_vm._v("Maked applied")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }